import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../css-dashboard/Dashboard.css";
import SidebarReceiver from "../../components/sidebar-dashboard/SidebarReceiver";
import ReceiverTripsProgressNegotiations from "../../components/receiver-trips-negotiations/ReceiverTripsProgressNegotiations";
import UseReceiverTripsNegotiations from "../../hooks/UseTripsNegotiations/UseReceiverTripsNegotiations";
import UseModalReceiverConfirmData from "../../hooks/UseModalReceiverConfirmData/UseModalReceiverConfirmData";
import ModalReceiverConfirmData from "../../components/modal-receiver-confirm-data/ModalReceiverConfirmData";
import UseModalPhotosOrder from "../../hooks/UseModalPhotosOrder/UseModalPhotosOrder";
import ModalPhotosOrder from "../../components/modal-photos-order/ModalPhotosOrder";
import UseModalChat from "../../hooks/UseModalChat/UseModalChat";
import ModalChat from "../../components/modal-chat/ModalChat";
import UseModalConfirmReceiptOrder from "../../hooks/UseModalConfirmReceiptOrder/UseModalConfirmReceiptOrder";
import ModalConfirmReceiptOrder from "../../components/modal-confirm-receipt-order/ModalConfirmReceiptOrder";

const DashboardReceiver = ({ menuOpen, setMenuOpen }) => {
  const location = useLocation();
  const { state, pathname } = location;
  const navigate = useNavigate();

  const [modalWarning, setModalWarning] = useState(true);
  const [fromNotification, setFromNotification] = useState(null);
  const [imageNotification, setImageNotification] = useState(null);
  const [messageNotification, setMessageNotification] = useState(null);

  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseReceiverTripsNegotiations();

  const {
    isOpenReceiverConfirmData,
    showSuccessScreenReceiverConfirmData,
    openModalReceiverConfirmData,
    closeModalReceiverConfirmData,
    selectedNegotiationReceiverConfirmData,
    actionTypeReceiverConfirmData,
    handleSubmit: handleSubmitReceiverConfirmData,
    loadingReceiverConfirmData,
    errorReceiverConfirmData,
    successReceiverConfirmData,
  } = UseModalReceiverConfirmData(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenPhotosOrder,
    showSuccessScreenPhotosOrder,
    selectedNegotiationPhotosOrder,
    photosPhotosOrder,
    loadingPhotosOrder,
    errorPhotosOrder,
    successPhotosOrder,

    openPhotosOrderModal,
    closePhotosOrderModal,

    handleChangePhotoOrder,
    handleSubmitPhotosOrder,
  } = UseModalPhotosOrder(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenChat,
    selectedNegotiationChat,
    currentRoleChat,
    messagesChat,
    messageChat,
    emojiList,
    setShowEmojiPickerChat,
    showEmojiPickerChat,
    handleEmojiSelect,
    loadingMessagesChat,
    sendingChat,
    errorChat,
    messagesEndRef,
    openChatModal,
    closeChatModal,
    handleMessageChange,
    handleSendMessage,
  } = UseModalChat(() => {
    refetchTripsNegotiations();
  });

  useEffect(() => {
    if ((fromNotification && state?.from) || state?.notification_type) {
      navigate(pathname, {
        replace: true,
        state: {
          ...state,
          from: null,
          notification_type: null,
        },
      });
    }
  }, [
    fromNotification,
    state?.from,
    state?.notification_type,
    pathname,
    navigate,
  ]);

  useEffect(() => {
    const state = location.state;
    if (!state || !state.from) return;

    const type = state.notification_type?.trim();
    const item = state.item;

    if (type === "receiver-removed") {
      setFromNotification("notification");
      setImageNotification("https://pngfre.com/wp-content/uploads/X-1.png");
      setMessageNotification(
        <>Infelizmente você foi removido como destinatário da encomenda!</>,
      );
    } else if (
      location.state?.item?.is_receiver_data_confirmed === false &&
      type === "receiver-selected"
    ) {
      openModalReceiverConfirmData(item, "confirm");
    } else if (
      location.state?.item?.is_traveler_photos_confirmed === true &&
      type === "photo-upload-receiver"
    ) {
      openPhotosOrderModal(item, "upload");
    } else if (type === "chat") {
      openChatModal(item, "receiver");
    }
  }, [location]);

  const {
    isOpenConfirmReceiptOrder,
    showSuccessScreenConfirmReceiptOrder,
    openModalConfirmReceiptOrder,
    closeModalConfirmReceiptOrder,
    selectedNegotiationConfirmReceiptOrder,
    formDataConfirmReceiptOrder,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingConfirmReceiptOrder,
    errorConfirmReceiptOrder,
    successConfirmReceiptOrder,
    errorsConfirmReceiptOrder,
  } = UseModalConfirmReceiptOrder(() => {
    refetchTripsNegotiations();
  });

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarReceiver menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Destinatário</h1>
            <p className="breadcrumb">
              <a href="/dashboard-receiver">Início</a> / Encomendas em Andamento
            </p>
          </div>

          <ReceiverTripsProgressNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverConfirmModal={openModalReceiverConfirmData}
            onOpenPhotosOrderModal={openPhotosOrderModal}
            onOpenChatModal={openChatModal}
            onOpenModalConfirmReceiptOrder={openModalConfirmReceiptOrder}
          />
        </main>
      </div>
      <ModalReceiverConfirmData
        isOpenReceiverConfirmData={isOpenReceiverConfirmData}
        showSuccessScreenReceiverConfirmData={
          showSuccessScreenReceiverConfirmData
        }
        closeModalReceiverConfirmData={closeModalReceiverConfirmData}
        selectedNegotiationReceiverConfirmData={
          selectedNegotiationReceiverConfirmData
        }
        actionTypeReceiverConfirmData={actionTypeReceiverConfirmData}
        handleSubmit={handleSubmitReceiverConfirmData}
        loadingReceiverConfirmData={loadingReceiverConfirmData}
        errorReceiverConfirmData={errorReceiverConfirmData}
        successReceiverConfirmData={successReceiverConfirmData}
      />

      <ModalPhotosOrder
        isOpenPhotosOrder={isOpenPhotosOrder}
        closePhotosOrderModal={closePhotosOrderModal}
        showSuccessScreenPhotosOrder={showSuccessScreenPhotosOrder}
        selectedNegotiationPhotosOrder={selectedNegotiationPhotosOrder}
        photosPhotosOrder={photosPhotosOrder}
        loadingPhotosOrder={loadingPhotosOrder}
        errorPhotosOrder={errorPhotosOrder}
        successPhotosOrder={successPhotosOrder}
        modePhotosOrder="upload"
        handlePhotoChange={handleChangePhotoOrder}
        handleSubmit={handleSubmitPhotosOrder}
      />

      <ModalChat
        isOpenChat={isOpenChat}
        selectedNegotiationChat={selectedNegotiationChat}
        currentRoleChat={currentRoleChat}
        messagesChat={messagesChat}
        messageChat={messageChat}
        emojiList={emojiList}
        setShowEmojiPickerChat={setShowEmojiPickerChat}
        showEmojiPickerChat={showEmojiPickerChat}
        handleEmojiSelect={handleEmojiSelect}
        loadingMessagesChat={loadingMessagesChat}
        sendingChat={sendingChat}
        errorChat={errorChat}
        messagesEndRef={messagesEndRef}
        closeChatModal={closeChatModal}
        handleMessageChange={handleMessageChange}
        handleSendMessage={handleSendMessage}
      />

      <ModalConfirmReceiptOrder
        isOpenConfirmReceiptOrder={isOpenConfirmReceiptOrder}
        showSuccessScreenConfirmReceiptOrder={
          showSuccessScreenConfirmReceiptOrder
        }
        closeModalConfirmReceiptOrder={closeModalConfirmReceiptOrder}
        formDataConfirmReceiptOrder={formDataConfirmReceiptOrder}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingConfirmReceiptOrder={loadingConfirmReceiptOrder}
        errorConfirmReceiptOrder={errorConfirmReceiptOrder}
        errorsConfirmReceiptOrder={errorsConfirmReceiptOrder}
        successConfirmReceiptOrder={successConfirmReceiptOrder}
        selectedNegotiationConfirmReceiptOrder={
          selectedNegotiationConfirmReceiptOrder
        }
      />

      {modalWarning && fromNotification === "notification" && (
        <div
          className="modal-overlay"
          onClick={() => {
            setModalWarning(false);
            setFromNotification(null);
          }}
          style={{
            alignItems: "flex-start",
            overflowY: "auto",
            padding: "20px 12px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "520px",
              margin: "auto",
              padding: "32px 28px",
              borderRadius: "30px",
              overflow: "hidden",
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(255, 255, 255, 0.92))",
              backdropFilter: "blur(18px)",
              WebkitBackdropFilter: "blur(18px)", // Garante suporte para o Safari
              boxShadow:
                "0 20px 60px rgba(15, 124, 255, 0.18), 0 8px 20px rgba(0, 0, 0, 0.06)",
              textAlign: "center",
            }}
          >
            <>
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  marginBottom: "22px",
                }}
              >
                <div
                  style={{
                    width: "155px",
                    height: "155px",
                    margin: "auto",
                    borderRadius: "50%",
                    padding: "5px",
                    background: "linear-gradient(135deg, #0f7cff, #19b8ff)",
                    boxShadow:
                      "0 14px 35px rgba(15, 124, 255, 0.35), 0 5px 14px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.35s ease",
                  }}
                >
                  <img
                    src={imageNotification}
                    alt="Foto de perfil"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "5px solid #fff",
                      display: "block",
                    }}
                  />
                </div>
              </div>

              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  textAlign: "left",
                  color: "#616367",
                  marginBottom: "6px",
                }}
              >
                {messageNotification || ""}
              </div>

              <div className="modal-actions">
                <button
                  type="button"
                  className="action-btn ghost"
                  onClick={() => {
                    setModalWarning(false);
                    setFromNotification(null);
                  }}
                >
                  Entendi
                </button>
              </div>
            </>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardReceiver;
